 import api from "../../../api.js";

export async function fetchNextScriptNumber() {
  const res = await api.get("/next-script-id");
  return res.data?.data?.nextScriptNumber || null;
}

export async function fetchPatients(searchTerm = "") {
  const res = await api.get("/patients", { params: { search: searchTerm } });
  return res.data?.data || [];
}

export async function fetchProfileInfo(profileNo) {
  const res = await api.get(`/profiles/${encodeURIComponent(profileNo)}/info`);
  return res.data?.data;
}

export async function fetchProfileFamily(profileNo) {
  const res = await api.get(`/profiles/${encodeURIComponent(profileNo)}/family`);
  return res.data?.data || [];
}

export async function fetchPatientScripts(patientId, branchcode) {
  const params = {};
  if (branchcode) params.branchcode = branchcode;
  const res = await api.get(`/patients/${encodeURIComponent(patientId)}/scripts`, { params });
  return res.data?.data || [];
}

export async function fetchPatientMedicationHistory(patientId) {
  const res = await api.get(`/patients/${encodeURIComponent(patientId)}/scripts/history`);
  return res.data?.data || [];
}

export async function fetchScriptDetails(scriptId) {
  const res = await api.get(`/scripts/${encodeURIComponent(scriptId)}/details`);
  return res.data?.data;
}

export async function fetchScriptDocumentHistory(scriptId) {
  const res = await api.get(`/scripts/${encodeURIComponent(scriptId)}/documents`);
  return res.data?.data || [];
}

export async function fetchFollowUp(scriptId) {
  const res = await api.get(`/scripts/${encodeURIComponent(scriptId)}/followup`);
  return res.data?.data || null;
}

export async function saveFollowUp(scriptId, payload) {
  const res = await api.post(`/scripts/${encodeURIComponent(scriptId)}/followup`, payload);
  return res.data?.data;
}

export async function createProcessPrescription(payload, file) {
  // When a script document file is provided, send payload + file as
  // multipart/form-data so the server can upload to S3 and persist docurl
  // in the same request. Otherwise, fall back to JSON body.
  if (file) {
    const form = new FormData();
    form.append("payload", JSON.stringify(payload));
    form.append("file", file);
    const res = await api.post("/scripts/process", form, {
      headers: { "Content-Type": "multipart/form-data" },
      // Script documents upload to S3 inside this request; that can take longer than
      // the default 10s API timeout, so give the file upload a generous window.
      timeout: 60000,
    });
    console.log('[createProcessPrescription API] Response (multipart):', res.data);
    return res.data;
  }
  const res = await api.post("/scripts/process", payload);
  console.log('[createProcessPrescription API] Response:', res.data);
  return res.data;
}

// Save selected repeat drugs for a given repeat row
// payload: { repeatid: number, items: [{ prescriptionDrugId, quantity?, status? }] }
export async function saveRepeatDrugs(payload) {
  const res = await api.post("/scripts/repeat-drugs", payload);
  return res.data;
}

// Mark a repeat as signed/pending and create a payment row linked to that repeat
// repeatId: number, payload: { paymenttype?, gross?, dispensingfee?, deliveryoption?, preferreddate?, preferredtime? }
export async function signRepeat(repeatId, payload = {}) {
  const res = await api.post(`/scripts/repeats/${encodeURIComponent(repeatId)}/sign`, payload);
  console.log('[signRepeat API] Response:', res.data);
  return res.data;
}

// Roll back a prescription whose MediKredit claim was rejected
export async function discardRejectedPrescription(prescriptionId) {
  const res = await api.delete(`/scripts/${encodeURIComponent(prescriptionId)}/discard`);
  return res.data;
}

// Search purchase table by prescription ID to get receipt number
export async function getReceiptByPrescriptionId(prescriptionId) {
  const res = await api.get(`/purchase/prescription/${encodeURIComponent(prescriptionId)}/receipt`);
  console.log('[getReceiptByPrescriptionId API] Response:', res.data);
  return res.data;
}
